var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible || _vm.delayed)?_c('div',{staticClass:"uik-overlay",style:({ 'background-color': 'rgba(0, 0, 0, ' + (_vm.opacity/100) + ')' }),on:{"click":_vm.close}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }